window.Fingerprint2_new = require('fingerprintjs2');
